<template>
  <div class="banner">
    <img src="@/assets/banner.png">
  </div>
</template>

<script>
export default {
  name: 'BannerComponent'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.banner {
  background-color: #FFECA1;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-image: url('@/assets/banner.png');
  background-position: center;
  background-size: max(80vw, 30px);
  background-repeat: no-repeat; */
}

img {
  width: min(80vw, 500px);
}

</style>
